import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "768b2adc-ed4c-4fb1-b20c-43ffad871967",
  title: "Pfitzinger/Douglas: Up to 55 miles per week, 18-week schedule",
  sourceName: "Advanced Marathoning",
  sourceUrl: "https://www.amazon.com/gp/product/B07PPRH66H/ref=as_li_tl?ie=UTF8&tag=codyhoover-20&camp=1789&creative=9325&linkCode=as2&creativeASIN=B07PPRH66H&linkId=2d5713afeeff31d780b3522d13c240fd",
  raceType: "Marathon",
  units: "miles",
  workouts: [
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Lactate threshold 8 miles w/ 4 miles @ 15K to half marathon pace",
      totalDistance: 8,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic 9 miles",
      totalDistance: 9,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "Medium-long run 12 miles",
      totalDistance: 12,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic + speed 8 miles w/ 10x100m strides",
      totalDistance: 8,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "Marathon-pace run 13 miles w/ 8 miles @ marathon race pace",
      totalDistance: 13,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description:
        "Lactate threshold 8 miles w/ 4 miles @ 15K to half marathon race pace",
      totalDistance: 8,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "Medium-long run 14 miles",
      totalDistance: 14,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic + speed 8 miles w/ 10x100m strides",
      totalDistance: 8,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "Medium-long run 15 miles",
      totalDistance: 15,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description:
        "Lactate threshold 9 miles w/ 5 miles @ 15K to half marathon race pace",
      totalDistance: 9,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "Marathon-pace run 16 miles w/ 10 miles @ marathon race pace",
      totalDistance: 16,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic + speed 8 miles w/ 10x100m strides",
      totalDistance: 8,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "Medium-long run 12 miles",
      totalDistance: 12,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description:
        "Lactate threshold 10 miles w/ 5 miles @ 15K to half marathon race pace",
      totalDistance: 10,
    },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "Medium-long run 11 miles",
      totalDistance: 11,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic + speed 7 miles w/8x100m strides",
      totalDistance: 7,
    },
    { description: "Long run 18 mi (34 km)", totalDistance: 18 },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery + speed 7 miles w/ 6x100m strides",
      totalDistance: 7,
    },
    {
      description: "Medium-long run 12 miles",
      totalDistance: 12,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description:
        "Lactate threshold 10 miles w/ 6 miles @ 15K to half marathon race pace",
      totalDistance: 10,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "Long run 20 miles",
      totalDistance: 20,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    {
      description: "Medium-long run 14 miles",
      totalDistance: 14,
    },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery + speed 6 miles w/ 6x100m strides",
      totalDistance: 6,
    },
    {
      description: "Marathon-pace run 16 miles w/ 12 miles @ marathon race pace",
      totalDistance: 16,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description:
        "VO₂ Max 8 miles w/ 5x800 m @ 5K race pace; jog 50 to 90% interval time between",
      totalDistance: 8,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic + speed 8 miles w/8x100m strides",
      totalDistance: 8,
    },
    {
      description: "Medium-long run 14 miles",
      totalDistance: 14,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery + speed 7 miles w/ 6x100m strides",
      totalDistance: 7,
    },
    {
      description:
        "Lactate threshold 11 miles w/ 7 miles @ 15K to half marathon race pace",
      totalDistance: 11,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Medium-long run 12 miles",
      totalDistance: 12,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "Long run 20 miles",
      totalDistance: 20,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description:
        "VO₂ Max 8 miles w/ 5x600 m @ 5K race pace; jog 50 to 90% interval time between",
      totalDistance: 8,
    },
    {
      description: "Medium-long run 12 miles",
      totalDistance: 12,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery + speed 5 miles w/ 6x100m strides",
      totalDistance: 5,
    },
    {
      description: "8K-15K tune-up race (total 9 miles to 13 miles)",
      totalDistance: 9,
    },
    {
      description: "Long run 17 miles",
      totalDistance: 17,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description:
        "VO₂ Max 9 miles w/ 5x1,000m @ 5K race pace; jog 50 to 90% interval time between",
      totalDistance: 9,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Medium-long run 12 miles",
      totalDistance: 12,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "Marathon-pace run 18 miles w/ 14 miles @ marathon race pace",
      totalDistance: 18,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description:
        "VO₂ Max 8 miles w/ 5x600 m @ 5K race pace; jog 50 to 90% interval time between",
      totalDistance: 8,
    },
    {
      description: "Medium-long run 11 miles",
      totalDistance: 11,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery + speed 4 miles w/ 6x100m strides",
      totalDistance: 4,
    },
    {
      description: "8K-15K tune-up race (total 9 miles to 13 miles)",
      totalDistance: 9,
    },
    {
      description: "Long run 17 miles",
      totalDistance: 17,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery + speed 7 miles w/ 6x100m strides",
      totalDistance: 7,
    },
    {
      description:
        "VO₂ Max 10 miles w/ 4x1,200m @ 5K race pace; jog 50 to 90% interval time between",
      totalDistance: 10,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Medium-long run 11 miles",
      totalDistance: 11,
    },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "Long run 20 miles",
      totalDistance: 20,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description:
        "VO₂ Max 8 miles w/ 5x600 m @ 5K race pace; jog 50 to 90% interval time between",
      totalDistance: 8,
    },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery + speed 4 miles w/ 6x100m strides",
      totalDistance: 4,
    },
    {
      description: "8K-10K tune-up race (total 9 miles to 11 miles)",
      totalDistance: 9,
    },
    {
      description: "Long run 16 miles",
      totalDistance: 16,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "General aerobic + speed 7 miles w/8x100m strides",
      totalDistance: 7,
    },
    {
      description:
        "VO₂ Max 8 miles w/ 3x1,600m @ 5K race pace; jog 50 to 90% interval time between",
      totalDistance: 8,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Recovery + speed 5 miles w/ 6x100m strides",
      totalDistance: 5,
    },
    { description: "Rest or cross-training", totalDistance: 0 },
    {
      description: "Medium-long run 12 miles",
      totalDistance: 12,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    {
      description: "Dress rehearsal 7 miles w/ 2 miles @ marathon race pace",
      totalDistance: 7,
    },
    { description: "Rest", totalDistance: 0 },
    {
      description: "Recovery + speed 5 miles w/ 6x100m strides",
      totalDistance: 5,
    },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    { description: "Goal marathon 26.2mi", totalDistance: 26.2 },
  ],
} as BuiltInPlan;
